'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var SvgIcon = require('../../library/DataDisplay/SvgIcon.js');
var iconStyles = require('../iconStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ChartIncrease = function ChartIncrease(props) {
  return React__default["default"].createElement(SvgIcon, _objectSpread({}, props, {
    viewBox: "0 0 24 24"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("style", null, '.cls-1 { fill: none; }')), React__default["default"].createElement("rect", {
    className: "cls-1",
    width: "24",
    height: "24"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("path", {
    d: "M19.75,3.72c.07-.21-.04-.43-.25-.5l-3.36-1.14c-.21-.07-.43,.04-.5,.25-.07,.21,.04,.43,.25,.5l2.99,1.01-1.01,2.99c-.07,.21,.04,.43,.25,.5,.21,.07,.43-.04,.5-.25l1.14-3.36Zm-1.46,1.11L5.83,10.97c-.3,.15-.67,.02-.82-.28h0c-.15-.3-.02-.67,.28-.82L17.75,3.73c.3-.15,.67-.02,.82,.28h0c.15,.3,.02,.67-.28,.82Z"
  }), React__default["default"].createElement("path", {
    d: "M5.56,11.28c-.09,0-.19-.02-.28-.05-.22-.07-.39-.23-.49-.43s-.12-.44-.04-.66c.07-.22,.23-.39,.43-.49L17.43,3.62l-1.62-.55c-.34-.11-.52-.48-.4-.82,.05-.16,.17-.29,.33-.37,.16-.08,.33-.09,.49-.03l3.36,1.14c.16,.06,.29,.17,.37,.33s.09,.33,.03,.49l-1.14,3.36c-.11,.34-.48,.52-.82,.4-.34-.11-.52-.48-.4-.82l.54-1.58L5.94,11.2c-.12,.06-.25,.09-.38,.09ZM18.02,3.92c-.05,0-.11,.01-.16,.04L5.4,10.1c-.09,.04-.15,.12-.18,.21-.03,.09-.02,.19,.02,.28,.04,.09,.12,.15,.21,.18,.09,.03,.19,.02,.28-.02l12.46-6.14c.18-.09,.25-.3,.16-.48-.06-.13-.19-.2-.32-.2Zm-2-1.61s-.04,0-.06,.01c-.03,.02-.06,.05-.07,.08-.03,.08,.01,.16,.09,.18l3.22,1.09-1.09,3.22c-.03,.08,.01,.16,.09,.18,.07,.03,.16-.01,.18-.09l1.14-3.36s0-.08,0-.11c-.02-.03-.05-.06-.08-.07l-3.36-1.14s-.03,0-.05,0Z"
  })), React__default["default"].createElement("rect", {
    x: "4.98",
    y: "14.01",
    width: "3.65",
    height: "7.92"
  }), React__default["default"].createElement("rect", {
    x: "10.01",
    y: "11.1",
    width: "3.65",
    height: "10.83"
  }), React__default["default"].createElement("rect", {
    x: "15.15",
    y: "8.13",
    width: "3.65",
    height: "13.81"
  }));
};

var ChartIncrease$1 = iconStyles()(ChartIncrease);

module.exports = ChartIncrease$1;
